import React, { useEffect, useState } from 'react';
import {
  RestApiErrorList,
  AsyncApiErrorList,
} from '@cdk-prod/fortellis-api-error-component';
import { useSelector } from 'react-redux';
import { API_ERROR_THEME } from '../../../../constants/constants';
import { environmentURLs } from '../../../common/CaptureEnvironment';
import { TextButton } from 'cdk-radial';
import './APIErrors.css';

const APIErrors = () => {
  const state = useSelector((state) => state);
  const { authenticationToken } = state?.loginDetailsSlice;
  const appErrorTheme = API_ERROR_THEME.DEALER_API_ERROR;
  const appId = state?.orderAPISlice?.orders?.app?.id;
  const [showRestErrors, setShowRestErrors] = useState(true);
  const config = {
    env: environmentURLs.REACT_APP_ENV,
    api: {
      solutionUrl: environmentURLs.REACT_APP_API_EMAIL_SOLUTION_SERVICE,
      apiGatewayDirectoryBaseUrl:
        environmentURLs.REACT_APP_API_GATEWAY_DIRECTORY_URL,
      metricServiceUrl: environmentURLs.REACT_APP_METRICS_SERVICE_URL_V1,
      asyncApiServiceBaseUrl: environmentURLs.REACT_APP_ASYNC_API_SERVICE,
    },

    apidocs: {
      url: environmentURLs.REACT_APP_METRICS_SERVICE_URL_V1,
    },
  };
  return (
    <>
      <div className="api-errors-navigation">
        {!showRestErrors ? (
          <TextButton
            dataTestId="primary-button"
            iconColor="primary"
            iconSize={24}
            onClick={() => setShowRestErrors(true)}
            size="standard"
            text="Rest Errors"
            isDisabled={showRestErrors}
          />
        ) : (
          <TextButton
            dataTestId="primary-button"
            iconColor="primary"
            iconSize={24}
            onClick={() => setShowRestErrors(false)}
            size="standard"
            text="Async Errors"
            isDisabled={!showRestErrors}
          />
        )}
      </div>
      {showRestErrors ? (
        <RestApiErrorList
          belongsTo={appErrorTheme}
          auth={{ accessToken: authenticationToken }}
          params={{ id: appId }}
          config={config}
        />
      ) : (
        <AsyncApiErrorList
          belongsTo={appErrorTheme}
          auth={{ accessToken: authenticationToken }}
          params={{ id: appId }}
          config={config}
        />
      )}
    </>
  );
};
export default APIErrors;
